import createSimpleComponent from '../createSimpleComponent'

import cls from './Widget.module.scss'

export default createSimpleComponent({
  displayName: 'UikWidgetContainer',
  className: cls.container,
  Component: 'div',
})
